// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__E+AJ0","logo":"styles_logo__xzdqF","profile_image":"styles_profile_image__820wN","button":"styles_button__bA7cO"};